/** Every tunable of the gesture, in one place. Distances in inches (scene units), times in ms. */
export const APPLIANCE_DRAG = {
	holdMs: { touch: 350, mouse: 250 },
	/** Pointer travel while armed that cancels the hold and lets the camera gesture proceed */
	cancelPx: { touch: 8, mouse: 4 },
	/** Pop-out: along the panel normal, toward the viewer */
	liftOutIn: 4,
	/** Extra lift for countertop (top-placed) appliances only */
	liftUpIn: 2,
	liftScale: 1.04,
	liftMs: 150,
	/** Survivors sliding to their previewed slot */
	previewMs: 160,
	/** The dragged column's centre line anywhere over another column (|x − target.x| ≤ enter × target.width) makes it the swap target ... */
	swapEnterFraction: 0.5,
	/** ... and it stays the target until the centre line is a little past the edge (hysteresis), so the mode does not flicker there */
	swapExitFraction: 0.54,
	/** Beyond an island footprint, how far a pointer still "belongs" to it */
	islandCaptureMarginIn: 12,
	/** Cutout regeneration (CSG) waits this long after the last plan change, so a sweep across the island costs a few passes, not one per neighbour crossed */
	cutoutPreviewDebounceMs: 90,
	/** ...but never wait longer than this while plan changes keep coming, so holes keep up with continuous motion */
	cutoutPreviewMaxWaitMs: 250,
	settleMs: 200,
	snapBackMs: 220,
	/** The floor label in front of the lifted column: plane size, distance out from the panel face, height above the floor, fade-in */
	indicator: { widthIn: 48, heightIn: 12, offsetIn: 16, floorLiftIn: 0.3, fadeMs: 120 },
	/** Glide of the column around a corner when the candidate island changes (instead of a snap) */
	hopMs: 180,
	/** Fine-tune mode: the spacing lines' distance out from the panel face and their number labels' size */
	fineTune: { dimensionOffsetIn: 8, labelWidthIn: 12, labelHeightIn: 5 },
	/** The drop assessment (a cloned kitchen, ~100 ms) runs this long after the slot last changed */
	assessDebounceMs: 350,
	tint: {
		lifted: { color: 0xffffff, intensity: 0.18 },
		swapTarget: { color: 0x59c3ff, min: 0.15, max: 0.45, periodMs: 700 },
		refused: { color: 0xff4040, intensity: 0.3 }
	},
	hapticMs: 8
} as const;
